<template>
    <div v-if="addons.length" class="journey-addons" :class="{ detailed }">
        <Divider
            v-if="detailed"
            color="lightGrey"
            bottomMargin="xxl"
            topMargin="xxl"
            thickness="1" />
        <div class="journey-addons-list">
            <Addon
                v-for="(addon, index) in addons"
                :detailed="detailed"
                :description="addon.description"
                :icon="addon.icon"
                :key="index" />
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, computed, PropType } from 'vue';
    import { capitalize } from 'lodash';
    import { JourneySegment } from '@ui/components/Journey/Journey.interfaces';
    import { getAddons } from '@/components/shared/Journey/Ferry/Shared/Addon.helpers';
    import Addon from './Addon.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'JourneyFerryAddons',
        methods: { t, capitalize },
        components: { Divider, Addon },
        props: {
            segment: {
                type: Object as PropType<JourneySegment>,
                required: true,
            },
            detailed: Boolean,
        },
        setup(props) {
            const addons = computed(() => {
                const extras = props.segment.extras ?? [];
                return getAddons(extras, props.detailed);
            });

            return {
                addons,
            };
        },
    });
</script>
<style lang="scss" scoped>
    @forward 'Addons';
</style>
